<div class="datagrid-wrapper"
     (dragover)="onDragOver($event)"
     (dragleave)="onDragLeave($event)"
     (drop)="onDrop($event)">

  <div class="page-controls">
    <!-- Upload Dropzone Component -->
    <app-upload-dropzone
      s3Prefix="ARCHIV"
      [allowedExtensions]="['.mp4', '.wav']"
      [maxFileSizeBytes]="2 * 1024 * 1024 * 1024"
      [disabled]="!canManageBroadcasts"
      (uploadComplete)="onUploadComplete($event)"
      (uploadError)="onUploadError($event)">
    </app-upload-dropzone>

    <div class="page-header">
      <div class="header-title">
        <h3>Archiv-Transkriptionen</h3>
      </div>
      <div class="header-actions">
        <clr-input-container>
          <label>Suche</label>
          <input clrInput type="text" placeholder="Titel oder EpisodeID suchen..."
                 [ngModel]="searchTerm"
                 (ngModelChange)="onSearchChange($event)" />
        </clr-input-container>
      </div>
    </div>
  </div>

  <clr-datagrid [clrDgLoading]="false">
    <clr-dg-column class="fixed-column col-status">Status</clr-dg-column>
    <clr-dg-column clrDgField="title" [clrDgSortOrder]="sortOrder">Titel der Sendung</clr-dg-column>
    <clr-dg-column clrDgField="episodeId" class="fixed-column col-episodeid">EpisodeID</clr-dg-column>
    <clr-dg-column class="fixed-column col-editors">Bearbeiter</clr-dg-column>
    <clr-dg-column class="fixed-column col-duration">Dauer</clr-dg-column>
    <clr-dg-column class="fixed-column col-created">Erstellt</clr-dg-column>
    <clr-dg-column class="fixed-column col-done">Abschluss</clr-dg-column>
    <clr-dg-column class="fixed-column col-actions"></clr-dg-column>

    <clr-dg-row *clrDgItems="let broadcast of broadcastList()" [clrDgItem]="broadcast">
      <clr-dg-cell class="fixed-column col-status">
        <div class="icon-wrapper">
          <img class="task-icon" [src]="'assets/live.active.svg'"
            [attr.title]="getStatusDescription(broadcast)" [ngClass]="{
              'icon-black': broadcast.status === 'uploaded',
              'icon-red': broadcast.status === 'transcribing',
              'icon-green': broadcast.status === 'done'
            }" />
        </div>
      </clr-dg-cell>

      <clr-dg-cell class="text-cell ellipsis">
        {{ broadcast.title }}
      </clr-dg-cell>

      <clr-dg-cell class="text-cell fixed-column col-episodeid">
        {{ broadcast.episodeId }}
      </clr-dg-cell>

      <clr-dg-cell class="text-cell fixed-column col-editors">
        <div *ngFor="let editor of broadcast.editors">
          {{ editor }}
        </div>
      </clr-dg-cell>
      <clr-dg-cell class="text-cell fixed-column col-duration">
        {{broadcast.bruttoDuration| durationFormat}}
      </clr-dg-cell>
      <clr-dg-cell class="text-cell fixed-column col-created">
        {{broadcast.createdAt | date: 'dd.MM.yyyy HH:mm'}}
      </clr-dg-cell>
      <clr-dg-cell class="text-cell fixed-column col-done">
        {{broadcast.wavTranscriptCreatedAt | date: 'dd.MM.yyyy HH:mm'}}
      </clr-dg-cell>

      <clr-dg-cell class="fixed-column col-actions action-buttons">
        <button *ngIf="broadcast.wavTranscriptRearrangedCreatedAt || broadcast.transcriptModifiedDate || (broadcast.key.startsWith('ARCHIV/') && (broadcast.wavTranscriptCreatedAt || broadcast.wavKey))" class="edit-button" (click)="editBroadcast(broadcast)" title="Bearbeiten">
          <cds-icon shape="pencil" solid></cds-icon>
        </button>
        <ng-container *hasPermission="'delete-archive'">
          <button class="delete-button" (click)="confirmDelete(broadcast)" title="Löschen">
            <cds-icon shape="trash" solid></cds-icon>
          </button>
        </ng-container>
      </clr-dg-cell>
    </clr-dg-row>

    <clr-dg-placeholder>
      <span *ngIf="searchTerm">Keine Ergebnisse für "{{searchTerm}}"</span>
      <span *ngIf="!searchTerm">Keine Transkriptionen vorhanden</span>
    </clr-dg-placeholder>

    <clr-dg-footer>
      <div class="pagination-controls">
        <div class="page-size-selector">
          <label>Pro Seite:</label>
          <select [(ngModel)]="pageSize" (ngModelChange)="onPageSizeChange($event)">
            <option *ngFor="let size of pageSizeOptions" [value]="size">{{size}}</option>
          </select>
        </div>
        <span class="pagination-info">
          Seite {{currentPage}} · {{broadcastList().length}} von {{totalItems}} Transkriptionen
        </span>
        <div class="pagination-buttons">
          <button class="btn btn-sm btn-outline"
                  [disabled]="currentPage === 1 || isLoading"
                  (click)="onPreviousPage()">
            <cds-icon shape="angle" direction="left"></cds-icon>
            Zurück
          </button>
          <button class="btn btn-sm btn-outline"
                  [disabled]="!nextToken || isLoading"
                  (click)="onNextPage()">
            Weiter
            <cds-icon shape="angle" direction="right"></cds-icon>
          </button>
        </div>
      </div>

      <button class="btn btn-sm btn-primary" (click)="exportToCsv()">
        <cds-icon shape="download" solid></cds-icon>
        Exportieren
      </button>
    </clr-dg-footer>
  </clr-datagrid>

  <!-- Overlay Editor Panel -->
  <app-overlay-panel *ngIf="editorVisible" mode="center" size="xl"
                     ariaLabel="Transkription bearbeiten" (closed)="closeEditor()">
    <span overlay-title>
      <span class="op-title-main">{{ selectedBroadcast?.title }}</span>
      <span class="op-title-sub" *ngIf="selectedBroadcast?.subtitle">{{ selectedBroadcast?.subtitle }}</span>
    </span>
    <app-transcription-editor [broadcast]="selectedBroadcast"></app-transcription-editor>
  </app-overlay-panel>

  <!-- Delete Confirmation Dialog -->
  <clr-modal [(clrModalOpen)]="deleteDialogVisible" [clrModalClosable]="!isDeleting">
    <h3 class="modal-title">Transkription löschen</h3>
    <div class="modal-body">
      <p>Sind Sie sicher, dass Sie diese Transkription löschen möchten?</p>
      <p *ngIf="broadcastToDelete"><strong>{{ broadcastToDelete.title }}</strong></p>
      <p class="delete-warning">
        <cds-icon shape="warning-standard" solid></cds-icon>
        Diese Aktion kann nicht rückgängig gemacht werden. Alle zugehörigen Dateien werden ebenfalls gelöscht.
      </p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline" (click)="cancelDelete()" [disabled]="isDeleting">Abbrechen</button>
      <button type="button" class="btn btn-danger" (click)="executeDelete()" [disabled]="isDeleting">
        <span *ngIf="!isDeleting">Löschen</span>
        <span *ngIf="isDeleting">Wird gelöscht...</span>
      </button>
    </div>
  </clr-modal>
</div>
